import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderJobByUpdatedAtPipe',
})
export class OrderJobByUpdatedAtPipe<T extends any> implements PipeTransform {
  constructor() {}

  public transform(items: T[]): T[] {
    if (!items) {
      return items;
    }
    return items.sort(
      (a, b) =>
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
    );
  }
}
